import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { IssueDetail, ProjectIssuesService } from "../../services/project-issues.service";

@Component({
  selector: "app-issue-details",
  templateUrl: "./issue-details.component.html",
  styleUrls: ["./issue-details.component.css"],
})
export class IssueDetailsComponent implements OnInit {
  issue: IssueDetail | null = null;
  loading = false;
  errorMessage = "";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private projectIssuesService: ProjectIssuesService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const issueId = params.get("id");
      if (!issueId) {
        this.errorMessage = "Issue id is missing.";
        return;
      }
      this.loadIssue(issueId);
    });
  }

  loadIssue(issueId: number | string): void {
    this.loading = true;
    this.errorMessage = "";

    this.projectIssuesService.getIssueDetail(issueId).subscribe(
      (res) => {
        this.issue = res;
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.errorMessage = "Unable to load issue details.";
      }
    );
  }

  backToIssues(): void {
    this.router.navigate(["/all-issues"]);
  }

  getStatusClass(status: string): string {
    if (status === "Resolved") return "status-resolved";
    if (status === "Forwarded") return "status-forwarded";
    return "status-pending";
  }
}
